<div class="custom-input-container">
  <label class="custom-input-label" *ngIf="label">
    {{ label }}
    <span class="required-indicator" *ngIf="required">*</span>
  </label>
  
  <div class="input-wrapper" [class.has-suffix]="suffixTemplate">
    <input
      [type]="type"
      [value]="value"
      [disabled]="disabled"
      [class]="inputClasses"
      [attr.inputmode]="inputMode ?? (type === 'tel' ? 'tel' : null)"
      [attr.pattern]="inputMode === 'numeric' ? '[0-9]*' : null"
      [attr.autocomplete]="type === 'tel' ? 'tel' : null"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      [attr.aria-invalid]="hasError"
      [attr.aria-describedby]="hasError ? 'error-' + label : null"
    />
    
    <div *ngIf="suffixTemplate" class="input-suffix">
      <ng-container *ngTemplateOutlet="suffixTemplate"></ng-container>
    </div>
  </div>
  
  <div 
    class="error-message" 
    [class.visible]="hasError"
    [id]="'error-' + label"
    role="alert"
  >
    {{ errorMessage }}
  </div>
</div>
